var render = function render(){var _vm=this,_c=_vm._self._c;return _c('layout-main',{scopedSlots:_vm._u([{key:"toolbar",fn:function(){return [_c('layout-tool-bar')]},proxy:true}])},[_c('v-container',{staticClass:"fill-wh"},[(_vm.$route.name !== 'PM Home')?_c('router-view'):_c('nav-tiles',{attrs:{"tiles":_vm.tiles},on:{"click:tile":_vm.navigate}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }